export enum Role {
    AI = "ai",
    USER = "user",
    LIVE_AGENT = "live_agent"
}

export enum ChatResponseType {
    TEXT = "TEXT",
    IMAGE = "IMAGE",
    VISUALIZATION = "VISUALIZATION",
    SUPPORT = "SUPPORT",
    LIVE_AGENT_EVENT = "LIVE_AGENT_EVENT",
    FORM_INPUT = "FORM_INPUT",
    ERROR = "ERROR",
    IDLE_STATE = "IDLE_STATE",
    DASHBOARD_WIDGET_PREVIEW = "DASHBOARD_WIDGET_PREVIEW",
    DASHBOARD_WIDGET_MODIFY = "DASHBOARD_WIDGET_MODIFY",
    DASHBOARD_WIDGET_ACTION = "DASHBOARD_WIDGET_ACTION",
    FLOORPLAN_VARIATION_MODIFY = "FLOORPLAN_VARIATION_MODIFY",
    SUPPORT_TICKETS = "SUPPORT_TICKETS",
    SUBSCRIPTION_RESTRICTION = "SUBSCRIPTION_RESTRICTION"
}

export enum UserSentiment {
    DISLIKE = "DISLIKE",
    NEUTRAL = "NEUTRAL",
    LIKE = "LIKE"
}

export enum FeedbackState {
    SUBMIT_SENTIMENT = 0,
    CONFIRM_FEEDBACK = 1,
    SUBMIT_FEEDBACK = 2,
    CANCEL = 3
}

export enum ChatStatus {
    CHAT_INIT = "CHAT_INIT",
    CHAT_ACTIVE = "CHAT_ACTIVE",
    WAITING_FOR_AGENT = "WAITING_FOR_AGENT",
    ENDING_CHAT = "ENDING_CHAT"
}

export enum SkillType {
    CHAT = "chat",
    VISION = "vision",
    LINK = "link",
    INLINE_ACTION_CHAT = 'inline_action_chat'
}

export enum IdleStatusType {
    USER_IDLE = "USER_IDLE",
    AGENT_IDLE = "AGENT_IDLE",
    AGENT_TIMED_OUT = "AGENT_TIMED_OUT"
}

export enum IdleTimeOut {
    USER_IDLE = 1000 * 60 * 20,
    AGENT_IDLE = 1000 * 60 * 5,
    AGENT_TIMED_OUT = 1000 * 60 * 20
}

export enum IdleStateMessage {
    USER_IDLE = "Your session has timed out due to inactivity. Feel free to start a new one if you need assistance",
    AGENT_TIMED_OUT = "Your session with the live agent has timed out due to inactivity. You can start a new session if you still need live support.",
    AGENT_IDLE = "Unfortunately, no live agent is available to assist you at the moment. You’ve been reconnected to {this.agentName}. Please try again later for live support."
}

export enum ReservedTags {
    ENTITY_REF = "$__{ENTITY_REF}__$"
}

export enum LinkType {
    INTERNAL = "internal",
    EXTERNAL = "external"
}

export enum ChatProfileId {
    DEFAULT = "default",
    PRECONFIGURATION = "preconfiguration",
    GENERATIVE_WIDGET_PREVIEW = "generativeWidgetPreview",
    GENERATIVE_DASHBOARD_WIDGET_EDITOR = "generativeDashboardWidgetEditor",
    OCCUPANT = "occupant",
    GLOBAL = "global"
}